import React from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

import Loading from 'src/components/loading';

const FileLoading: (props: any) => JSX.Element = props => (
  <Loading size="medium" {...props} />
);

export default styled(FileLoading)`
  margin: 0 auto;
  padding: ${gridSize() * 8}px;
`;
